import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type FlyoutDrawerState = Readonly<{
    locationLink: {
        flyoutDrawerIsOpen: boolean;
    },
    miniCart: {
        flyoutDrawerIsOpen: boolean;
    },
}>;

const initialState: FlyoutDrawerState = {
    locationLink: {
        flyoutDrawerIsOpen: false,
    },
    miniCart: {
        flyoutDrawerIsOpen: false,
    },
};

const FlyoutDrawerData = createTypedReducerWithImmer(initialState, {
    "Custom/FlyoutDrawer/SetLocationLinkFlyoutDrawerIsOpen": (
        draft: Draft<FlyoutDrawerState>, 
        action: { isOpen: boolean }
    ) => {
        draft.locationLink.flyoutDrawerIsOpen = action.isOpen;
    },
    "Custom/FlyoutDrawer/SetMiniCartFlyoutDrawerIsOpen": (
        draft: Draft<FlyoutDrawerState>, 
        action: { isOpen: boolean }
    ) => {
        draft.miniCart.flyoutDrawerIsOpen = action.isOpen;
    },
});

export default (reducers as any).xcentiumFlyoutDrawer = FlyoutDrawerData;

export type CustomFlyoutDrawerState = {
    xcentiumFlyoutDrawer: FlyoutDrawerState;
} & ApplicationState;

type Reducers = {
    flyoutDrawerReducer: typeof FlyoutDrawerData;
};

export type XCentiumFlyoutDrawerActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
